import { render, staticRenderFns } from "./TitleWithSubtitleActionsAndActionText.vue?vue&type=template&id=1f57deea&"
import script from "./TitleWithSubtitleActionsAndActionText.vue?vue&type=script&lang=js&"
export * from "./TitleWithSubtitleActionsAndActionText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports